import * as Sentry from "@sentry/vue";

export function initSentry(app) {
    if (!import.meta.env.VITE_SENTRY_DSN) return
    Sentry.init({
        app,
        dsn: import.meta.env.VITE_SENTRY_DSN,
        sendDefaultPii: false
    })
}

export default Sentry